import { createFileRoute } from "@tanstack/react-router";
import { HospitalerPage, hospitalerHead } from "@/pages/HospitalerPage";

export const Route = createFileRoute("/en/industries/hospitals-healthcare")({
  head: () => hospitalerHead("en"),
  component: () => <HospitalerPage locale="en" />,
});
